/**
 * CMCD request mode variable name.
 *
 *
 * @beta
 */
export const CMCD_REQUEST_MODE = 'request'
